<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<col style="width:340px;" />
						<col style="width:130px;" />
						<col style="width:300px;" />
						<col style="width:120px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>PO No</th>
							<td>
								<input type="text" v-model.trim="purchase.po_dn" class="tbl_int ssm2_int" :readonly="mode == 'detail' || user.company_id != 'minkhair'" :disabled="mode == 'detail' || user.company_id != 'minkhair'" />
								<button v-if="mode == 'add' && user.company_id == 'minkhair'" v-bind:disabled="!purchase.po_dn" class="gray_bt2" @click="checkDup()">Check Dup.</button>
								<span style="margin-left:10px;">{{ purchase.po_type == 'B' ? 'Back Order' : 'New Order' }}</span>
								<!-- <select class="tbl_select" style="width:95px;" v-model="purchase.po_type" disabled>
									<option value="N">New Order</option>
									<option value="B">Back Order</option>
								</select> -->
								<template v-if="purchase.closed_yn == 'Y'"> (Closed)</template>
							</td>
							<th>Vendor</th>
							<td colspan="3">
								<div style="float:left;"><PartnerSelect v-model="purchase.vendor_code" :initialName="purchase.vendor_name" ph="Vendor" :showName="true" :vendorOnly="true" @set-partner="setVendor" /></div>
							</td>
						</tr>
						<tr>
							<th>PO Date</th>
							<td>
								<CustomDatePicker v-model="purchase.po_date" />
								<span style="margin-left:20px;color:blue;font-weight:bold;" v-if="item_sum.total_shipped_quantity > 0"> {{ item_sum.total_shipped_quantity == item_sum.total_quantity ? 'All' : 'Partially' }} Shipped </span>
							</td>
							<th>Est. Ship Date</th>
							<td><CustomDatePicker v-model="purchase.estimated_ship_date" /> <a v-if="user.company_id != 'minkhair'" href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="applyEsdToItems(true)">Apply to Item(s)</a></td>
							<th>ETA Date</th>
							<td><CustomDatePicker v-model="purchase.eta_date" /> <a v-if="user.company_id != 'minkhair'" href="javascript:;" class="gray_bt2" style="margin-left:5px;" @click="applyEtaDateToItems(true)">Apply to Item(s)</a></td>
						</tr>
						<tr>
							<th>Payment Term</th>
							<td><CodeSelect className="tbl_select" :codes="paymentTerms" v-model="purchase.payment_term_code" /></td>
							<th>Trade Term</th>
							<td><CodeSelect className="tbl_select" :codes="tradeTerms" v-model="purchase.trade_term_code" /></td>
							<th>Location</th>
							<td><CodeSelect class-name="tbl_select" :codes="locationTypes" v-model="purchase.location_code" /></td>
						</tr>
						<tr>
							<th>Delivery Type</th>
							<td><CodeSelect className="tbl_select" :codes="deliveryTypes" v-model="purchase.po_delivery_type_code" /></td>
							<th>Payment Type</th>
							<td><CodeSelect className="tbl_select" :codes="paymentTypes" v-model="purchase.payment_type_code" /></td>
							<template v-if="user.company_id == 'jc'">
								<th>Purchaser</th>
								<td>
									<select v-model="purchase.purchaser_id" class="tbl_select lm_int">
										<option :value="null"></option>
										<option v-for="pu in users" v-bind:value="pu.user_id" v-bind:key="pu.user_id">{{ pu.name }}</option>
									</select>
								</td>
							</template>
						</tr>
						<tr>
							<th>Hold Type</th>
							<td><CodeSelect className="tbl_select" :codes="holdTypes" v-model="purchase.po_hold_type_code" /></td>
							<!-- <th>Qty/Amt.(Shipped)</th> -->
							<th>Item Qty / Amt</th>
							<td>
								<template v-if="user.company_id == 'minkhair'">
									<template v-if="item_sum.total_shipped_quantity > 0">
										<currency-input type="text" v-model="item_sum.total_remain_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
										<currency-input type="text" v-model="item_sum.total_remain_amount" class="tbl_int ssm_int al_right" readonly />
									</template>
									<template v-else>
										<currency-input type="text" v-model="purchase.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
										<currency-input type="text" v-model="item_sum.total_amount" class="tbl_int ssm_int al_right" readonly />
									</template>
								</template>
								<template v-else>
									<currency-input type="text" v-model="purchase.total_quantity" :precision="0" class="tbl_int ssm_int al_right" readonly />
									<currency-input type="text" v-model="item_sum.total_amount" class="tbl_int ssm_int al_right" readonly />
								</template>
							</td>

							<th><span v-if="user.company_id != 'minkhair'">DC / Total Amount</span></th>
							<td>
								<currency-input v-if="user.company_id != 'minkhair'" type="text" v-model="purchase.discount_amount" class="tbl_int ssm_int al_right" />
								<currency-input v-if="user.company_id != 'minkhair'" type="text" v-model="purchase.total_amount" class="tbl_int ssm_int al_right" style="font-weight:bold;" readonly />
								<label for="closed_yn" style="margin-left:15px;"> <input type="checkbox" id="closed_yn" v-model="purchase.closed_yn" true-value="Y" false-value="N" />Closed</label>
							</td>
						</tr>
						<tr>
							<th>Description</th>
							<td colspan="3"><input type="text" v-model.trim="purchase.description" class="tbl_int" /></td>
							<th>Remark</th>
							<td><input type="text" v-model.trim="purchase.remark" class="tbl_int" /></td>
						</tr>
						<tr v-if="user.admin_yn == 'Y'">
							<td colspan="6">Created : {{ purchase.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ purchase.crt_user }}, Last updated : {{ purchase.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} {{ purchase.upd_user }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- New Item -->
			<div class="left_option">
				<!-- <em style="padding-left:20px;padding-right:10px;"><b>Search Item(s) : </b></em> -->
				<em v-if="false" class="lt_text">Item {{ headers.class }}</em>
				<span v-if="false" class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" @set-item-class="setItemClass" /> </span>

				<span class="int_type half_int">
					<!-- <input type="text" v-model.trim="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" /> -->
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" placeholder="Item / Class Name or Code"> </autocomplete>
				</span>

				<a href="javascript:;" class="search_bt mgr_15" @click="search()">Search and Add Item(s)</a>
				<input type="file" v-if="this.purchase.vendor_code" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="!this.purchase.vendor_code" @change="readFile" />
				<span v-if="this.purchase.vendor_code">* Excel Format : {{ headers.class }}, Color, Quantity</span>
				<!-- <a href="javascript:;" class="gray_bt" @click="reset()">Reset</a> -->
			</div>

			<table class="list_tbl mgb_0 add_top_line" ref="purchase_items" border="0">
				<thead>
					<tr>
						<th width="30px;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
						<th width="150px;">{{ user.company_id == 'minkhair' ? 'Item Code' : headers.class }}</th>
						<th width="150px;" v-if="profile.show_item_code == 'Y'">Item Code</th>
						<th>Name</th>
						<th v-if="user.company_id != 'jc'" width="140px;">Color</th>
						<template v-if="user.company_id == 'minkhair'">
							<th width="5%">Order</th>
							<th width="5%">Rcvd</th>
							<th width="5%">Bk Ord</th>
							<th width="5%">Unit Cost</th>
							<th width="5%">Amount</th>
						</template>
						<template v-else>
							<th style="width: 3%;" v-if="user.company_id == 'he'">Rack</th>
							<th style="width: 5%;" v-if="factory_code_show">Factory Code</th>
							<th width="5%">Qty</th>
							<th width="5%">Cost / Price</th>
							<th width="5%">Amount</th>
							<th width="5%">FOB Cost</th>
							<th width="5%">FOB Amount</th>
							<th width="3%">Pack</th>
							<th width="6%">ESD</th>
							<th width="6%">ETA Date</th>
							<th width="5%">Shipped Qty</th>
							<th width="5%">Remain Qty</th>
							<th width="5%">Remain Amt.</th>
						</template>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in items" v-bind:key="item.po_item_no">
						<!-- <td class="al_center"><input type="checkbox" v-model="item.selected" :disabled="item.shipped_quantity > 0" /></td> -->
						<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
						<td class="al_left">
							<!-- {{ item.class_code }} -->
							<template v-if="user.company_id == 'minkhair'">
								{{ item.item_code }}
							</template>
							<template v-else>
								<template v-if="index == 0 || (index > 0 && item.class_code != items[index - 1].class_code)">
									{{ item.class_code }}<span v-if="item.class_so_blocked">&nbsp;<font color="red">Blocked</font></span>
								</template>
							</template>
						</td>

						<td class="al_left" v-if="profile.show_item_code == 'Y'">{{ item.item_code }}</td>

						<td class="al_left">
							<input v-if="user.company_id == 'minkhair'" class="tbl_int" v-model="item.item_name" @focus="$event.target.select()" />
							<a v-else href="javascript:;" @click="selectItem(item)">{{ item.item_name }}</a>
						</td>
						<td v-if="user.company_id != 'jc'" class="al_left">{{ item.color_code }}</td>
						<td v-if="user.company_id == 'he'">
							{{ item.rack }}
						</td>
						<td v-if="factory_code_show">
							{{ item.im_factory_code }}
						</td>
						<td class="al_right">
							<currency-input
								type="text"
								v-model.trim="item.quantity"
								:precision="0"
								class="r_int long_type al_right"
								@focus="$event.target.select()"
								ref="quantity"
								@keydown.down.prevent="goTo('quantity', index + 1)"
								@keydown.up.prevent="goTo('quantity', index - 1)"
								@keydown.right.prevent="goTo('unit_price', index)"
								@keydown.left.prevent="goTo('unit_price', index - 1)"
								:style="item.packing > 0 && item.quantity % item.packing != 0 ? 'color:red;' : 'color:black;'"
							/>
						</td>
						<template v-if="user.company_id == 'minkhair'">
							<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
							<td class="al_right">{{ item.remain_quantity | commaSeparatedZeroNull }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model="item.unit_price"
									:precision="profile.po_decimal_point"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="unit_price"
									:style="item.im_cost != item.unit_price ? 'color:red;' : 'color:black'"
									@keydown.down.prevent="goTo('unit_price', index + 1)"
									@keydown.up.prevent="goTo('unit_price', index - 1)"
									@keydown.right.prevent="goTo('fob_price', index)"
									@keydown.left.prevent="goTo('quantity', index)"
									@input="priceInputEvent(index, item.class_code, item.cost, $event)"
								/>
							</td>
							<td class="al_right">{{ item.shipped_quantity > 0 ? item.remain_amount : item.amount | toPOCurrency(profile.po_decimal_point) }}</td>
							<!-- <td class="al_left"><CustomDatePicker v-model="item.esd" /></td>
							<td class="al_left"><CustomDatePicker v-model="item.eta_date" /></td> -->
						</template>
						<template v-else>
							<td class="al_right">
								<currency-input
									type="text"
									v-model="item.unit_price"
									:precision="profile.po_decimal_point"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="unit_price"
									:style="item.im_cost != item.unit_price ? 'color:red;' : 'color:black'"
									@keydown.down.prevent="goTo('unit_price', index + 1)"
									@keydown.up.prevent="goTo('unit_price', index - 1)"
									@keydown.right.prevent="goTo('fob_price', index)"
									@keydown.left.prevent="goTo('quantity', index)"
									@input="priceInputEvent(index, item.class_code, item.cost, $event)"
								/>
							</td>
							<td class="al_right">{{ item.amount | toPOCurrency(profile.po_decimal_point) }}</td>
							<td class="al_right">
								<currency-input
									type="text"
									v-model="item.fob_price"
									:precision="profile.po_decimal_point"
									class="r_int long_type al_right"
									@focus="$event.target.select()"
									ref="fob_price"
									:style="item.im_fob != item.fob_price ? 'color:red;' : 'color:black'"
									@keydown.down.prevent="goTo('fob_price', index + 1)"
									@keydown.up.prevent="goTo('fob_price', index - 1)"
									@keydown.right.prevent="goTo('quantity', index + 1)"
									@keydown.left.prevent="goTo('unit_price', index)"
									@input="priceInputEvent2(index, item.class_code, item.cost, $event)"
								/>
							</td>
							<td class="al_right">{{ item.fob_amount | toPOCurrency(profile.po_decimal_point) }}</td>
							<td class="al_right">{{ item.packing | commaSeparated }}</td>
							<td class="al_left"><CustomDatePicker v-model="item.esd" /></td>
							<td class="al_left"><CustomDatePicker v-model="item.eta_date" /></td>
							<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
							<!-- <td class="al_right">{{ (item.quantity - item.shipped_quantity) | commaSeparatedZeroNull }}</td> -->
							<td class="al_right">{{ item.remain_quantity | commaSeparatedZeroNull }}</td>
							<td class="al_right">{{ item.remain_amount | toPOCurrency(profile.po_decimal_point) }}</td>
						</template>
					</tr>
					<tr>
						<td :colspan="totalColspan" class="al_right"><font color="red">Total</font></td>
						<td class="al_right" style="padding-right:8px;">
							<font color="red">{{ item_sum.total_quantity | commaSeparated }}</font>
						</td>
						<template v-if="user.company_id == 'minkhair'">
							<td class="al_right">
								<font color="red">{{ item_sum.total_shipped_quantity | commaSeparated }}</font>
							</td>
							<td class="al_right">
								<font color="red" v-if="item_sum.total_remain_quantity != 0">{{ item_sum.total_remain_quantity | commaSeparated }}</font>
							</td>
							<td></td>
							<td class="al_right">
								<font color="red"> {{ item_sum.total_shipped_quantity > 0 ? (item_sum.total_remain_amount > 0 ? item_sum.total_remain_amount : '') : item_sum.total_amount | toPOCurrency(profile.po_decimal_point) }} </font>
							</td>
						</template>
						<template v-else>
							<td></td>
							<td class="al_right">
								<font color="red"> {{ item_sum.total_amount | toPOCurrency(profile.po_decimal_point) }} </font>
							</td>
							<td></td>
							<td class="al_right">
								<font color="red"> {{ item_sum.total_fob_amount | toPOCurrency(profile.po_decimal_point) }} </font>
							</td>
							<td colspan="3"></td>
							<td class="al_right">
								<font color="red">{{ item_sum.total_shipped_quantity | commaSeparated }}</font>
							</td>
							<td class="al_right">
								<font color="red" v-if="item_sum.total_remain_quantity != 0">{{ item_sum.total_remain_quantity | commaSeparated }}</font>
							</td>
							<td class="al_right">
								<font color="red" v-if="item_sum.total_remain_quantity != 0"> {{ item_sum.total_remain_amount | toPOCurrency(profile.po_decimal_point) }} </font>
							</td>
						</template>
					</tr>
				</tbody>
			</table>

			<div class="tbl_bottom_bt">
				<input type="button" value="Delete" class="int_line_bt" @click="deleteItems()" />
				<span style="padding-left:20px"># of item row:</span>
				<input type="text" readonly disabled="disabled" style="width:40px;" class="r_int long_type al_right" v-model="items.length" />

				<template v-if="user.company_id != 'minkhair'">
					<CustomDatePicker v-model="dateForCheck" />
					<input type="button" value="Apply ESD" class="int_line_bt" @click="applyEsdToItems(false)" />
					<input type="button" value="Apply ETA" class="int_line_bt" @click="applyEtaDateToItems(false)" />
				</template>
			</div>

			<div class="view_bottom_bt">
				<a v-if="purchase.po_no" href="javascript:;" type="button" class="gray_bt fl_l mgr_5" @click="purchaseOrderPrint(false)">Print (Original)</a>
				<a v-if="purchase.po_no && item_sum.total_shipped_quantity > 0 && item_sum.total_quantity != item_sum.total_shipped_quantity" href="javascript:;" type="button" class="gray_bt fl_l" @click="purchaseOrderPrint(true)">
					Print (Remaining)
				</a>
				<a v-if="purchase.po_no" href="javascript:;" type="button" class="gray_bt fl_l mgl_15" @click="excelExport()">Excel</a>

				<a href="javascript:;" type="button" class="gray_bt fl_l mgl_15" @click="adjustCosts">Adjust Cost / FOB to Item Master's</a>

				<a v-if="modifiable && mode == 'detail' && !purchase.backorder_po_no && purchase.total_quantity > 0 && item_sum.total_remain_quantity > 0" href="javascript:;" type="button" class="gray_bt mgr_15" @click="backOrder()"
					>Make Back Order</a
				>
				<a v-if="modifiable && mode == 'detail' && purchase.backorder_po_no" href="javascript:;" class="mgr_15" style="display:inline-block;padding-top:5px;" @click="openPO(purchase.backorder_po_no)"
					>Back Order : {{ purchase.backorder_po_dn }}</a
				>
				<a v-if="modifiable && mode == 'detail' && purchase.original_po_no" href="javascript:;" class="mgr_15" style="display:inline-block;padding-top:5px;" @click="openPO(purchase.original_po_no)"
					>Original Order: {{ purchase.original_po_dn }}</a
				>

				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt" @click="save(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" type="button" class="search_bt mgr_15" @click="save(true)">Save Only</a>

				<a v-if="modifiable && mode == 'detail' && !purchase.shipment_exists" href="javascript:;" type="button" class="gray_bt mgl_15 mgr_15" @click="del()">Delete</a>

				<a v-if="mode === 'detail'" href="javascript:;" type="button" class="gray_bt mgl_15" @click="openModal('prevPurchaseShipment')">Prev. P/O & Ship</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Cancel</a>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ItemSelect'" :draggable="false" style="z-index:2000">
			<template slot="title">Select Item(s)</template>
			<template slot="body">
				<ItemPopup :initialItems="searchItems" :initialItemClass="itemClass" :initialKeyword="keyword" :vendor_code="purchase.vendor_code" operation="P" v-on:close="closeModal()" @set-items="addItems" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'prevPurchaseShipment'" :draggable="false" style="z-index:2000">
			<template slot="title">Prev. P/O & Ship</template>
			<template slot="body">
				<PrevPurchaseShipmentModal :po_no="purchase.po_no" @close="closeModal" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectPurchase, apiInsertPurchase, apiUpdatePurchase, apiDeletePurchase, apiCheckPurchaseExists, apiSelectPurchaseItemList } from '@/api/purchase/purchase.js';
import { apiLoadFromExcel } from '@/api/item/master.js';
import { apiGetReportTemplate, Report, companyMrtUrl, exportDataExcel } from '@/api/util';
import { today } from '@/utils/date.js';
import { defaultDataType } from 'export-xlsx';

import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PrevPurchaseShipmentModal from '@/views/purchase/PrevPurchaseShipmentModal.vue';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemPopup from '@/components/common/ItemPopup';
import Modal from '@/components/common/Modal';

import _ from 'lodash';
import XLSX from 'xlsx-js-style';
import 'floatthead';
import { generateDefaultCompanyPurchaseOrderPrint } from '@/utils/purchaseUtils';

export default {
	props: ['headers'],
	data: function() {
		return {
			backUri: '/purchase/po_main',
			mode: 'add',
			purchase: {
				po_dn: null,
				discount_amount: null,
			},
			items: [],
			item_nos_to_delete: [],

			paymentTerms: [],
			tradeTerms: [],
			deliveryTypes: [],
			paymentTypes: [],
			locationTypes: [],
			holdTypes: [],
			users: [],

			remark: null,

			allSelected: false,

			itemClass: null,
			keyword: '',
			searchItems: [],

			modalName: '',
			showModal: false,

			dateForCheck: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		item_sum: function() {
			var s = { total_quantity: 0, total_amount: 0, total_fob_amount: 0, total_shipped_quantity: 0, total_remain_quantity: 0, total_remain_amount: 0 };

			this.items.forEach(i => {
				if (i.quantity) s.total_quantity += i.quantity;
				if (i.amount) s.total_amount += i.amount;
				if (i.fob_amount) s.total_fob_amount += i.fob_amount;
				if (i.shipped_quantity) s.total_shipped_quantity += i.shipped_quantity;
				if (i.remain_quantity) s.total_remain_quantity += i.remain_quantity;
				if (i.remain_amount) s.total_remain_amount += i.remain_amount;
			});
			return s;
		},

		factory_code_show: function() {
			return this.user.company_id === 'he';
		},

		totalColspan: function() {
			let colspan = 4;
			if (this.profile.show_item_code === 'Y') colspan++;
			if (this.factory_code_show) colspan++;

			if (this.user.company_id == 'he') colspan++;

			if (this.user.company_id == 'jc') colspan--;

			return colspan;
		},
	},
	watch: {
		purchase: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
		items: {
			deep: true,
			handler: function() {
				this.calTotal();
			},
		},
	},
	components: {
		PartnerSelect,
		CodeSelect,
		CustomDatePicker,
		ItemClassSelect,
		ItemPopup,
		Modal,
		PrevPurchaseShipmentModal,
	},
	methods: {
		readFile(event) {
			if (event.target.files.length == 0) return;
			var file = event.target.files[0];

			const reader = new FileReader();
			reader.onload = e => {
				let data = e.target.result;
				data = new Uint8Array(data); // get excel file
				let excelFile = XLSX.read(data, { type: 'array', raw: true });
				let sheetName = excelFile.SheetNames[0];
				const rows = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], { header: 1, raw: false });
				this.load(rows);
			};
			reader.readAsArrayBuffer(file);
		},
		async load(rows) {
			var excel_items = [];
			for (var i = 0; i < rows.length; i++) {
				excel_items.push({
					excel_row_no: i + 1,
					excel_class_code: rows[i][0],
					excel_color_code: rows[i][1],
					excel_quantity: rows[i][2],
				});
			}
			const { data } = await apiLoadFromExcel({
				for_purchase: true,
				vendor_code: this.purchase.vendor_code,
				excel_json_str: JSON.stringify(excel_items),
			});

			var valid_items = data.excelItemList.filter(i => i.active_yn == 'Y' && i.class_active_yn == 'Y' && i.class_closed_yn == 'N' && !i.so_blocked);
			var invalid_items = data.excelItemList.filter(i => i.active_yn == 'N' || i.class_active_yn == 'N' || i.class_closed_yn == 'Y' || i.so_blocked);

			var msg = '';
			msg = 'Excel items : ' + excel_items.length + '<br>';
			msg += 'Valid items : ' + valid_items.length + '<br>';
			msg += 'Invalid items : ' + invalid_items.length + '<br>';

			invalid_items.forEach(i => {
				msg += '<br>Invalid item: excel row ' + i.excel_row_no + ', item id ' + i.item_id;
				if (i.active_yn == 'N' || i.class_active_yn == 'N') msg += ', Inactive';
				if (i.class_closed_yn == 'Y') msg += ', Closed';
				if (i.so_blocked) msg += ', Blocked';
			});

			var to_add_items = [];
			valid_items.forEach(i => {
				i.quantity = i.excel_quantity;
				i.item_name = i.name;
				i.unit_price = i.net_price;
				i.amount = i.quantity * i.unit_price;
				i.fob_price = i.fob;
				i.fob_amount = i.quantity * i.fob_price;
				i.shipped_quantity = 0;
				to_add_items.push(_.cloneDeep(i));
			});

			this.mergeItems(to_add_items);

			this.$alertify.alert('Excel Import', msg);
		},
		async excelExport() {
			if (!this.purchase.po_no) return;

			const { data } = await apiSelectPurchaseItemList({ po_no: this.purchase.po_no });
			const purchaseItemList = data.purchaseItemList;
			if (!(purchaseItemList && purchaseItemList.length)) {
				this.$toast.error('No Data to Export.');
				return;
			}

			purchaseItemList.forEach(p => {
				if (!p.quantity) p.quantity = 0;
				if (!p.shipped_quantity) p.shipped_quantity = 0;
				if (!p.unit_price) p.unit_price = 0;
				p.remain_quantity = p.quantity - p.shipped_quantity;
				p.remain_amount = p.remain_quantity * p.unit_price;
			});

			const filename = 'PO_' + this.purchase.po_dn;

			const headers = [
				{ key: 'class_code', name: this.headers.class + ' Code', width: 20, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item Code', width: 30, dataType: defaultDataType.string },
				{ key: 'item_name', name: 'Item Name', width: 30, dataType: defaultDataType.string },
				{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string },
				{ key: 'unit_price', name: 'Price', width: 15, dataType: defaultDataType.number },
				{ key: 'quantity', name: 'Order Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'amount', name: 'Order Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'fob_price', name: 'FOB Price', width: 15, dataType: defaultDataType.number },
				{ key: 'fob_amount', name: 'FOB Amount', width: 15, dataType: defaultDataType.number },
				{ key: 'packing', name: 'Pack', width: 10, dataType: defaultDataType.currency },
				{ key: 'esd', name: 'ESD', width: 15, dataType: defaultDataType.string },
				{ key: 'eta_date', name: 'ETA', width: 15, dataType: defaultDataType.string },
				{ key: 'shipped_quantity', name: 'Shipped Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'remain_quantity', name: 'Remain Qty.', width: 15, dataType: defaultDataType.currency },
				{ key: 'remain_amount', name: 'Remain Amt.', width: 15, dataType: defaultDataType.number },
			];
			exportDataExcel(purchaseItemList, headers, filename);
		},
		openPO(po_no) {
			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { backUri: this.$route.fullPath, po_no: po_no } });
			window.open(routeData.href, 'herp_purchase');
		},
		backOrder() {
			this.mode = 'add';
			this.purchase.original_po_no = this.purchase.po_no;
			this.purchase.po_no = null;
			this.purchase.po_dn = null;
			this.purchase.po_type = 'B';
			this.purchase.po_date = today();
			this.purchase.estimated_ship_date = null;
			this.purchase.eta_date = null;

			var new_items = [];

			this.items.forEach(i => {
				if (i.quantity > i.shipped_quantity) {
					var new_item = _.cloneDeep(i);
					new_item.quantity = i.quantity - i.shipped_quantity;
					new_item.shipped_quantity = 0;
					new_item.esd = null;
					new_item.eta_date = null;

					new_items.push(new_item);
				}
			});

			this.items = new_items;
		},
		async checkDup() {
			if (await this.checkExists()) {
				this.$toast.error('Duplicate PO No');
			} else {
				this.$toast.success('Not Duplicate');
			}
		},
		async checkExists() {
			const { data } = await apiCheckPurchaseExists(this.purchase);
			return data.result;
		},
		applyEsdToItems(all) {
			var toApplyItems;
			var toApplyDate;
			if (all) {
				toApplyItems = this.items;
				toApplyDate = this.purchase.estimated_ship_date;
			} else {
				toApplyItems = this.items.filter(i => i.selected);
				toApplyDate = this.dateForCheck;
			}

			toApplyItems.forEach(i => {
				i.esd = toApplyDate;
			});
		},
		applyEtaDateToItems(all) {
			var toApplyItems;
			var toApplyDate;
			if (all) {
				toApplyItems = this.items;
				toApplyDate = this.purchase.eta_date;
			} else {
				toApplyItems = this.items.filter(i => i.selected);
				toApplyDate = this.dateForCheck;
			}

			toApplyItems.forEach(i => {
				i.eta_date = toApplyDate;
			});
		},
		adjustCosts() {
			this.items.forEach(i => {
				i.unit_price = i.im_cost;
				i.fob_price = i.im_fob;
			});
		},

		async generateMinkhairPurchaseOrderPrint(isRemaining) {
			if (isRemaining) {
				this.purchase.total_remain_quantity = this.item_sum.total_remain_quantity;
				this.purchase.total_remain_amount = this.item_sum.total_remain_amount;
			}

			// minkhair P/O
			const vm = this;
			const cbFunc = async include_price => {
				let item_groups = [];
				let separator = '  ';
				for (let item of vm.items) {
					let idx = item_groups.findIndex(g => g.class_name === item.class_name && g.unit_price === item.unit_price);
					let quantity = isRemaining ? item.remain_quantity : item.quantity;
					let amount = isRemaining ? item.remain_amount : item.amount;
					let qty_info_by_color = `${item.name === item.item_name ? item.color_code : item.item_name}-(${quantity})`;

					if (isRemaining && !quantity) continue;

					if (idx > -1) {
						item_groups[idx].quantity += quantity;
						item_groups[idx].amount += amount;
						item_groups[idx].qty_info_by_color += separator + qty_info_by_color;
					} else {
						item_groups.push({
							class_name: item.class_name,
							unit_price: item.unit_price,
							quantity,
							amount,
							qty_info_by_color,
						});
					}
				}

				let data = { isRemaining, include_price, purchase: vm.purchase, item_groups };
				let reportTemplate = await apiGetReportTemplate('PurchaseOrderDetail', companyMrtUrl('PurchaseOrderDetail'));
				const report = new Report(reportTemplate, data, 'PurchaseOrderDetail');
				vm.$store.commit('setReport', report);
			};

			this.$alertify.confirm(
				'Do You Want P/O Including Pricing Info',
				() => cbFunc(true),
				() => cbFunc(false),
			);
		},
		/**
		 * Print Purchase Order
		 * @param isRemaining
		 * @returns {Promise<*>}
		 */
		async purchaseOrderPrint(isRemaining) {
			let poNo = this.purchase.po_no;
			if (!poNo) return this.$toast.error('No Data To Be Shown');

			if (this.user.company_id === 'minkhair') {
				await this.generateMinkhairPurchaseOrderPrint(isRemaining);
			} else {
				await generateDefaultCompanyPurchaseOrderPrint(poNo, isRemaining, this.user);
			}
		},
		async del() {
			if (confirm('Are you sure to delete?')) {
				const { data } = await apiDeletePurchase(this.purchase);
				if (data.result) {
					this.$toast.success('Deleted successfully');
					this.$router.push(this.backUri);
				} else {
					this.$toast.error('Failed');
				}
			}
		},
		priceInputEvent(index, class_code, cost, price) {
			if (this.user.company_id == 'minkhair') return;

			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					this.items[i].unit_price = price + this.items[i].cost - cost;
				}
			}
		},
		priceInputEvent2(index, class_code, cost, fob_price) {
			if (this.user.company_id == 'minkhair') return;

			for (var i = index + 1; i < this.items.length; i++) {
				if (this.items[i].class_code == class_code) {
					this.items[i].fob_price = fob_price + this.items[i].cost - cost;
				}
			}
		},
		goTo(colType, index) {
			this.$nextTick(() => {
				if (index < this.items.length && index >= 0) {
					if (colType == 'unit_price') this.$refs.unit_price[index].$el.select();
					else if (colType == 'quantity') this.$refs.quantity[index].$el.select();
					else if (colType == 'fob_price') this.$refs.fob_price[index].$el.select();
				}
			});
		},
		selectClasses(input) {
			return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			this.itemClass = c.selectedObject.code;
			this.search();
		},
		searchKeyword(keyword) {
			this.$refs.ac.clear();
			this.keyword = keyword;
			this.search();
		},
		selectItem(item) {
			let routeData = this.$router.resolve({ name: 'itemMaster', params: {}, query: { backUri: this.$route.fullPath, keyword: item.item_id } });
			window.open(routeData.href, '_blank');
		},
		setItemClass() {
			this.search();
		},
		async search() {
			if (!this.purchase.vendor_code) {
				this.$toast.error('Select Vendor first.');
				return;
			}
			this.openModal('ItemSelect');
		},
		reset() {
			this.keyword = '';
			this.itemClass = null;
		},
		deleteItems() {
			const wrong_selected_list = this.items.filter(it => it.selected && it.shipment_exists);
			if (wrong_selected_list.length > 0) {
				const msg = `Shipping History for ${wrong_selected_list.map(el => el.item_code).join(', ')} in the P/O Already Exists.`;
				this.$alertify.alert('Alert', msg);
				return;
			}

			for (var i = this.items.length - 1; i >= 0; i--) {
				if (this.items[i].selected) {
					if (this.items[i].po_item_no) this.item_nos_to_delete.push(this.items[i].po_item_no);
					this.items.splice(i, 1);
				}
			}
		},
		copyItems() {
			if (this.items.length > 200) {
				this.$toast.error('Too many items');
				return;
			}

			if (this.items.length > 0) {
				this.$session.set('items', this.items);
				this.$toast.success('All item is copied');
			}
		},
		pasteItems() {
			//console.log(this.$session.get('items'));
			//var copiedItems = this.$session.get('items');
		},
		selectAll() {
			var vm = this;
			this.items.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},
		calTotal() {
			var total_amount = 0;
			var total_quantity = 0;

			this.items.forEach(function(item) {
				item.amount = item.quantity * item.unit_price;
				item.fob_amount = item.quantity * item.fob_price;

				item.remain_quantity = item.quantity - item.shipped_quantity;
				item.remain_amount = item.remain_quantity * item.unit_price;

				total_quantity += item.quantity;
				total_amount += item.amount;
			});
			this.purchase.total_quantity = total_quantity;
			this.purchase.total_amount = total_amount - this.purchase.discount_amount;
			this.purchase.item_amount = total_amount;
		},
		setVendor(partner) {
			this.purchase.vendor_name = partner.name;
		},
		async selectPurchase() {
			const { data } = await apiSelectPurchase({
				po_no: this.purchase.po_no,
			});

			this.purchase = data.purchase;
			this.items = data.purchaseItemList;
			this.items
				.filter(i => i.quantity == 0)
				.forEach(i => {
					i.selected = true;
				});
		},
		checkValidity() {
			if (this.user.company_id == 'minkhair' && !this.purchase.po_dn) {
				this.$toast.error('Empty PO No');
				return false;
			}

			if (!this.purchase.po_date) {
				this.$toast.error('Empty PO Date');
				return false;
			}

			if (!this.purchase.vendor_code) {
				this.$toast.error('Empty Vendor');
				return false;
			}
			return true;
		},
		async save(stay) {
			if (await this.checkValidity()) {
				await this.submit(stay);
			}
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		async submit(stay) {
			this.purchase.items = this.items;
			this.purchase.item_nos_to_delete = this.item_nos_to_delete;

			var response;
			if (this.mode == 'add') {
				if (await this.checkExists()) {
					this.$toast.error('Duplicate PO No');
					return;
				}
				response = await apiInsertPurchase(this.purchase);
			} else {
				response = await apiUpdatePurchase(this.purchase);
			}
			var data = response.data;

			if (data.result) {
				this.$toast.success('Saved successfully');

				if (!stay) {
					this.$router.push(this.backUri);
				} else {
					if (this.mode == 'add') {
						this.purchase.po_no = data.po_no;
						this.purchase.po_dn = data.po_dn;

						this.mode = 'detail';
						this.$store.commit('setSubTitle', 'Purchase Order -> Detail');
					}
					await this.selectPurchase();
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			if (this.modalName == 'ItemSelect') {
				this.keyword = '';
				this.itemClass = null;
			}

			this.showModal = false;
		},
		addItems(items) {
			var vm = this;
			items.forEach(function(item) {
				item.item_name = item.name;
				item.im_cost = item.cost;
				item.im_fob = item.fob;

				item.unit_price = item.net_price;
				if (item.fob) item.fob_price = item.fob;
				else item.fob_price = null;

				vm.items.push(item);
			});
			inputSelectOnClick();
			this.reset();
		},
		mergeItems(items) {
			var vm = this;
			var dupl_items = [];
			items.forEach(function(item) {
				var foundItems = vm.items.filter(i => i.item_id == item.item_id);
				if (foundItems.length > 0) {
					foundItems[0].quantity += item.quantity;
					dupl_items.push(item.item_code ? item.item_code : item.name + '(' + item.color_code + ')');
				} else {
					vm.items.push(_.cloneDeep(item));
				}
			});

			if (dupl_items.length > 0) {
				window.alert(dupl_items.join(', ') + ' Already Exist(s) in Purchase List.\nPlease Check the Quantity of These Products');
			}

			this.$forceUpdate();
		},
		async index() {
			const { data } = await apiIndex();

			this.paymentTerms = data.paymentTermList;
			this.tradeTerms = data.tradeTermList;
			this.deliveryTypes = data.poDeliveryTypeList;
			this.paymentTypes = data.paymentTypeList;
			this.holdTypes = data.poHoldTypeList;
			this.locationTypes = data.locationList;

			this.users = data.userList;
		},
		async init() {
			await this.index();

			if (this.mode == 'detail') {
				await this.selectPurchase();
			}
			inputSelectOnClick();
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_po_main');
		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Purchase Order -> Add');
			this.purchase.po_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Purchase Order -> Detail');
			this.purchase.po_no = this.$route.query.po_no;
			if (!this.purchase.po_no) {
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
	},
	mounted() {
		$(this.$refs.purchase_items).floatThead({ zIndex: 1, autoReflow: true });

		this.$nextTick(function() {
			if (this.mode == 'add') {
				if (this.user.company_id == 'newjigu') this.purchase.payment_term_code = 'TT';
				else this.purchase.payment_term_code = 'LC';

				this.purchase.trade_term_code = 'FOB';
				this.purchase.po_delivery_type_code = 'S';
				this.purchase.payment_type_code = 'NP';

				this.purchase.po_type = 'N';
			}
			inputSelectOnClick();
		});
	},
};
</script>

<style></style>
